import React from "react";
import logo from "../components/images/liqlogo.png"; // adjust if your logo path differs
import bgImage from "../components/images/aboutbg.png"; // replace with your desired background image

export default function About() {
  return (
    <section
      className="relative w-full min-h-screen flex items-center justify-center text-center text-white overflow-hidden"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dark overlay over entire background */}
      <div className="absolute inset-0 bg-black/80"></div>

      {/* Bounding box overlay */}
      <div className="relative z-10 max-w-auto mx-auto px-12 py-12 md:py-16 mt-2 md:mt-6">
        {/* Logo */}
        <div className="flex justify-center">
          <img
            src={logo}
            alt="Liquora Global Logo"
            className="h-32 md:h-64 mt-4 object-contain"
          />
        </div>

        {/* Description */}
        <p className="text-lg md:text-md font-body leading-relaxed text-white/90">
          Liquora Global stands as a premier name in the international alcohol trade, proudly serving as the <strong>exclusive importer and sole distributor</strong> of renowned global brands such as <strong>Wild Boar</strong>, <strong>Little Fat Lamb</strong>, and other premium beverage labels. With a deep passion for quality and craftsmanship, we bring to India an exceptional portfolio of beverages that celebrate the art of brewing, blending, and distillation.
        </p>

        <p className="text-lg md:text-md font-body leading-relaxed text-white/90 mt-6">
          Driven by a spirit of partnership and integrity, Liquora Global has built strong alliances with breweries, distilleries, and retailers across markets. Every label we represent is chosen with meticulous care, ensuring that our offerings reflect authenticity, innovation, and uncompromised quality. From our import operations to nationwide distribution, we maintain stringent standards and seamless logistics to guarantee that every product reaches customers in perfect condition.
        </p>

        <p className="text-lg md:text-md font-body leading-relaxed text-white/90 mt-6">
          As the exclusive gateway for some of the world’s most exciting alcohol brands, we go beyond distribution — we build experiences. At Liquora Global, we don’t just sell beverages; we share stories of heritage, craftsmanship, and global taste. Our vision is to continue shaping India’s premium alcohol landscape by bringing together exceptional brands, passionate partners, and consumers who appreciate the finer things in life.
        </p>
      </div>
    </section>
  );
}
